import React from "react";
import { NavigationLinks, Section } from "../../../components";
import { BannerPages, DownloadCondicoesGerais } from "../Sections";
import ImageNavigationLinks from "../../../assets/images/residencial/ilustracao-homem-casa.svg";

const CondicoesGeraisSeguroResidencial = () => {
  return (
    <>
      <BannerPages
        subtitle="Seguro Residencial"
        bannerTitle="Condições gerais"
      />
      <Section
        as={DownloadCondicoesGerais}
        sectionName="Download de condições gerais seguro residencial"
        tipoDeSeguroPage="residencial"
      />
      <Section
        as={NavigationLinks}
        sectionName="Ainda podemos te ajudar?"
        sectionTitle="Ainda podemos te ajudar?"
        imgSrc={ImageNavigationLinks}
      />
    </>
  );
};

export default CondicoesGeraisSeguroResidencial;
